export const PDFDownloadIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        id="icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" fill="#025a95" />
        <g transform="translate(6, 6) scale(0.7)">
          <path
            d="M21,21v4H5V21H3v4H3a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2h0V21Z"
            fill="#fff"
          />
          <polygon
            points="18 18 16.586 16.586 14 19.172 14 11 12 11 12 19.172 9.414 16.586 8 18 13 23 18 18"
            fill="#fff"
          />
          <polygon
            points="25 1 25 0 19 0 19 10 21 10 21 6 24 6 24 4 21 4 21 1 25 1"
            fill="#fff"
          />
          <path
            d="M15,10H11V0h4a3.0033,3.0033,0,0,1,3,3V7A3.0033,3.0033,0,0,1,15,10Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V3a1.0011,1.0011,0,0,0-1-1H13Z"
            fill="#fff"
          />
          <path
            d="M7,0H2V10H4V7H7a2.0027,2.0027,0,0,0,2-2V2A2.0023,2.0023,0,0,0,7,0ZM4,5V2H7l.001,3Z"
            fill="#fff"
          />
        </g>
        <rect
          id="_Transparent_Rectangle_"
          data-name="<Transparent Rectangle>"
          style={{ fill: 'none' }}
          width="32"
          height="32"
        />
      </svg>
    </>
  );
};
